export default "__VITE_ASSET__7988cc54__"